module.exports = __webpack_public_path__ + "static/media/rocket.5f68992b.svg";